/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementSettingEventCheckinResponse } from './EventManagementSettingEventCheckinResponse';

export type EventManagementSettingEventCheckinResponseApiRespoonse = {
    data?: EventManagementSettingEventCheckinResponse;
    status?: EventManagementSettingEventCheckinResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementSettingEventCheckinResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

